import { motion } from "framer-motion";
import { Sparkles, Zap, Wand2, AlertTriangle, BookOpen } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Eyebrow } from "@/components/landing/Eyebrow";
import { TAKEAWAYS, SCROLL_REVEAL } from "@/lib/content";

const ICONS = [
  <Sparkles className="w-3.5 h-3.5 sm:w-4 sm:h-4" />,
  <Zap className="w-3.5 h-3.5 sm:w-4 sm:h-4" />,
  <Wand2 className="w-3.5 h-3.5 sm:w-4 sm:h-4" />,
  <AlertTriangle className="w-3.5 h-3.5 sm:w-4 sm:h-4" />,
  <BookOpen className="w-3.5 h-3.5 sm:w-4 sm:h-4" />,
];

const TAGS = ["FRAMEWORK", "BREAKDOWN", "AI DEMO", "TRAPS", "EBOOK"];

export const Takeaways = () => {
  return (
    <section
      id="takeaways"
      data-testid="takeaways-section"
      className="relative bg-ink-soft py-12 sm:py-24 lg:py-28"
    >
      <div className="absolute top-0 left-0 right-0 hairline-h" aria-hidden />
      <div className="container px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto">
        <motion.div {...SCROLL_REVEAL} className="max-w-3xl">
          <Eyebrow label="TAKEAWAYS" sub="04" />
          <h2 className="font-serif-tc mt-4 sm:mt-7 text-[26px] leading-[1.15] sm:text-5xl lg:text-6xl font-bold tracking-[-0.02em]">
            4 項可<span className="lime-keyword">落地資產</span>
          </h2>
        </motion.div>

        {/* 2-col on mobile, 3-col on lg */}
        <div className="mt-6 sm:mt-14 grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-5 lg:gap-6">
          {TAKEAWAYS.map((t, i) => (
            <motion.div
              key={t.n}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.45, delay: i * 0.05 }}
              data-testid={`takeaway-card-${i}`}
              className={`card-dark p-4 sm:p-6 ${i === TAKEAWAYS.length - 1 ? "col-span-2 lg:col-span-1 lg:col-start-2" : ""}`}
            >
              <div className="flex items-start justify-between gap-2">
                <span className="font-num text-[9px] sm:text-[11px] font-bold text-[hsl(var(--muted-foreground))] tracking-[0.2em]">
                  {t.n} / {TAGS[i]}
                </span>
                <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-md sm:rounded-lg bg-[rgba(255,255,255,0.04)] border border-[rgba(255,255,255,0.08)] flex items-center justify-center text-[hsl(var(--foreground))]/80">
                  {ICONS[i]}
                </div>
              </div>

              {t.badge && (
                <span className="mt-3 inline-flex text-[9px] sm:text-[10px] px-1.5 sm:px-2 py-0.5 rounded-full border border-[rgba(212, 180, 106,0.35)] bg-[rgba(212, 180, 106,0.08)] text-[hsl(var(--lime))]">
                  {t.badge}
                </span>
              )}

              <h3 className="font-serif-tc mt-3 sm:mt-4 text-[15px] sm:text-xl lg:text-2xl font-bold text-[hsl(var(--foreground))] leading-snug">
                {t.title}
              </h3>
              <p className="mt-1.5 sm:mt-3 text-[11px] sm:text-[15px] leading-relaxed text-[hsl(var(--muted-foreground))] line-clamp-2 sm:line-clamp-none">
                {t.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
